var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloudOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92638 11.8823C2.04408 11.2917 1.46319 10.2859 1.46319 9.14448C1.46319 7.42993 2.77384 6.02152 4.4479 5.86647C4.79034 3.78345 6.59915 2.19434 8.77913 2.19434C10.9591 2.19434 12.7679 3.78345 13.1103 5.86647C14.7844 6.02152 16.0951 7.42993 16.0951 9.14448C16.0951 10.2859 15.5142 11.2917 14.6319 11.8823M5.85275 11.7051L8.77913 8.77868M8.77913 8.77868L11.7055 11.7051M8.77913 8.77868V15.363",
    stroke: "#F37721",
    strokeWidth: 1.72281,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloudOrange);
export default __webpack_public_path__ + "static/media/upload-cloud-orange.d91ecafad7437123fcabfbdf708832c8.svg";
export { ForwardRef as ReactComponent };